<script>
export default {
	mounted() {
		this.$auth0.loginWithRedirect({
			authorizationParams: {
				screen_hint: 'signup',
				login_hint: this.$route.query?.email
			}
		})
	}
}
</script>
